import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import {useAnalyticsConsent} from '~/hooks/use-consent'
import type {RootLoaderResponse} from '../../types'
interface GoogleAnalyticsProps {
  pageLoadIdCookie?: string
  measurementId?: string
  googleAdsKey?: string
  sharingPolicyDenied?: boolean
}

export const GoogleAnalyticsGdpr = ({
  pageLoadIdCookie,
  measurementId,
  googleAdsKey,
  sharingPolicyDenied,
}: GoogleAnalyticsProps) => {
  const {cookieConsentVariation, gdprConsentData} = useRouteLoaderData('root') as RootLoaderResponse
  const {optOutRejected} = useAnalyticsConsent()
  const defaultConsent = cookieConsentVariation === 'opt-in' ? 'denied' : 'granted'
  const consentPermission = gdprConsentData ?? defaultConsent

  const disableAnalytics =
    process.env.NODE_ENV === 'development' ||
    optOutRejected ||
    sharingPolicyDenied ||
    !measurementId ||
    !pageLoadIdCookie ||
    !googleAdsKey

  if (disableAnalytics) {
    return null
  }

  return (
    <>
      <script key="gtag-loader" async src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} />
      <script
        key="gtag-init"
        id="gtag-init"
        async
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('consent', 'default', {
            'ad_storage': "${consentPermission}",
            'ad_user_data': "${consentPermission}",
            'ad_personalization': "${consentPermission}",
            'analytics_storage': "${consentPermission}",
          });
          gtag("js", new Date());
          gtag("config", "${googleAdsKey}");
          gtag("config", "${measurementId}", { page_load_id: "${pageLoadIdCookie}", 'stack': 'remix', 'consent_mode': true });
          gtag("event", "nonceReady");
             `,
        }}
      />
    </>
  )
}
